<!--
* @Name：验收标的
* @Author: 王超
* @Date: 2025-10-28
-->
<template>
  <div>
    <hi-card v-for="(item, index) in detailsList" :key="item.id" :row-index="index + 1">
      <van-row>
        <span>行号：</span>
        <span>{{ item.lineNo }}</span>
      </van-row>
      <van-row>
        <span>物料编号：</span>
        <span>{{ item.matnr }}</span>
      </van-row>
      <van-row>
        <span>产品名称：</span>
        <span>{{ item.itemName }}</span>
      </van-row>
      <van-row>
        <span>规格型号：</span>
        <span>{{ item.standard }}</span>
      </van-row>
      <van-row>
        <span>单位：</span>
        <span>{{ item.unit | dictFilter(unitDictsOptions) }}</span>
      </van-row>
      <van-row>
        <span>到货日期：</span>
        <span>{{ item.arrivalDate }}</span>
      </van-row>
      <van-row>
        <span>单价：</span>
        <span>{{ item.productPrice }}</span>
      </van-row>
      <van-row>
        <span>产品数量：</span>
        <span>{{ item.productQty }}</span>
      </van-row>
      <van-row>
        <span>已验收数量：</span>
        <span>{{ item.acceptedQty }}</span>
      </van-row>
      <van-row>
        <span>剩余验收数量：</span>
        <span>{{ item.leftAccepteQty }}</span>
      </van-row>
      <van-row>
        <span>本次验收数量：</span>
        <span>{{ item.accepteQty }}</span>
      </van-row>
      <van-row>
        <span>本次验收金额：</span>
        <span>{{ item.accepteAmount }}</span>
      </van-row>
      <van-row>
        <span>销售合同编号：</span>
        <span>{{ item.salesContractNo }}</span>
      </van-row>
      <van-row>
        <span>销售合同行号：</span>
        <span>{{ item.salesContractLineNo }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'AcceptanceItemDetails',
  data() {
    return {}
  },
  props: {
    detailsList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    unitDictsOptions() {
      return this.$store.getters.dicts.bstme
    }
  },
  methods: {}
}
</script>
